module.exports = __webpack_public_path__ + "img/image-install-steps.2840145e.png";